module.exports = __webpack_public_path__ + "static/media/Gynhälsan uses telemedicine software for digital fertility care.8661bcd6.webp";